/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateScheduleDto } from '../../models/update-schedule-dto';

export interface ScheduleControllerUpdateRepeatV1$Params {
  id: string;
  repeatUpdateType: 'THIS' | 'THIS_AND_FUTURE' | 'ALL';
      body: UpdateScheduleDto
}

export function scheduleControllerUpdateRepeatV1(http: HttpClient, rootUrl: string, params: ScheduleControllerUpdateRepeatV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, scheduleControllerUpdateRepeatV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('repeatUpdateType', params.repeatUpdateType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

scheduleControllerUpdateRepeatV1.PATH = '/api/v1/schedule/{id}/repeat';
